// import { routesData, menuRoutes } from '@/router/index';
import request from '@/request/index';

const createTree = function (menus, pid, level = 3) {
    var list = [];
    for (const menu of menus) {
        if (menu.parentId === pid) {
            if (menu.type <= level) {
                const children = createTree(menus, menu.id, level);
                menu.children = children;
                menu.hasChildren = children.length !== 0 ? true : false;
                list.push(menu);
            } else {
                break;
            }
        }
    }
    return list;
};
const state = {
    sidebar: {
        opened: true
    },
    menuList: [],
    appList: [],
    appId: '' //应用切换ID
};
const getters = {
    MENU_GET: state => {
        return state.menuList;
    }
};
const mutations = {
    TOGGLE_SIDEBAR: state => {
        state.sidebar.opened = !state.sidebar.opened;
    },
    CLOSE_SIDEBAR: state => {
        state.sidebar.opened = false;
    },
    SET_APPLIST: (state, val) => {
        state.appList = val;
    },
    SET_MENULIST: (state, val) => {
        const list = createTree(val, 0);
        state.menuList = list;
    },
    SET_APPID: (state, val) => {
        state.appId = val;
    }
};
const actions = {
    toggleSideBar({ commit }) {
        commit('TOGGLE_SIDEBAR');
    },
    getAppListAction({ commit }) {
        return new Promise(async (resolve, reject) => {
            try {
                const result = await request('queryPerAppList');
                const appList = result.data;
                commit('SET_APPLIST', appList);
                resolve(appList);
            } catch (error) {
                reject(error);
            }
        });
    }
};
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
